import {Spin} from 'antd';
import React, {FC} from 'react';

import './custom-select-spinner.less';

interface ICustomSelectSpinnerProps {}

export const CustomSelectSpinner: FC<ICustomSelectSpinnerProps> = () => (
    <div
        className="custom-select-spinner"
    >
        <Spin
            className="custom-select-spinner__spin"
            size="small"
        />
        <div
            className="custom-select-spinner__label"
        >
            Загрузка...
        </div>
    </div>
);
